import { Box } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { orgTypeAtom } from "../store/onboardingModalStore";
import { OrgType } from "../types";
import { OnboardingSelectionCard } from "./shared/OnboardingSelectionCard";
import { OnboardingStepLayout } from "./shared/OnboardingStepLayout";

const orgTypeCards: { type: OrgType; title: string; description: string }[] = [
  {
    type: "msp",
    title: "Managed service provider (MSP)",
    description: "We provide IT services to multiple clients",
  },
  {
    type: "internal_it",
    title: "Internal IT team",
    description: "We manage IT for our own organization",
  },
];

export const OnboardingOrgType = (): JSX.Element => {
  const [orgType] = useAtom(orgTypeAtom);
  const setOrgType = useSetAtom(orgTypeAtom);

  return (
    <OnboardingStepLayout
      title="Tell us about your organization"
      subtitle="This helps us customize your DeskDay experience."
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {orgTypeCards.map((card) => (
          <OnboardingSelectionCard
            key={card.type}
            title={card.title}
            description={card.description}
            isSelected={orgType === card.type}
            onClick={() => setOrgType(card.type)}
          />
        ))}
      </Box>
    </OnboardingStepLayout>
  );
};
